import { render, staticRenderFns } from "./BuyBoxFilter.vue?vue&type=template&id=61d42ea0&scoped=true"
import script from "./BuyBoxFilter.vue?vue&type=script&setup=true&lang=ts"
export * from "./BuyBoxFilter.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BuyBoxFilter.vue?vue&type=style&index=0&id=61d42ea0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d42ea0",
  null
  
)

export default component.exports